import { gql } from '@apollo/client/core';
import { DOCUMENT_LIST_TITLE_FRAGMENT } from '../document-gql';
import { CALLOUT_CONTENT_FRAGMENT } from '../callout-content-gql';
import { IDPDATA_ALBERTACA_FRAGMENT } from '@govalta-emu/keycloak-auth-service';

//Use this if we can't nest snapshot value object
//this just means we can't recursively reference valueCollection but should be OK because i think we only have 1 level of sub questions
export const SNAPSHOT_VALUE_FRAGMENT_STATIC = `
  fieldName
  label
  value
  headerCollection
  subHeader
  questionHeader
  displayMode
  documentList {
    ${DOCUMENT_LIST_TITLE_FRAGMENT}
  }
  documentsPersonal {
    ${DOCUMENT_LIST_TITLE_FRAGMENT}
  }
  documentsSpouse {
    ${DOCUMENT_LIST_TITLE_FRAGMENT}
  }
  valueCollection {
    fieldName
    label
    value
    headerCollection
    subHeader
    questionHeader
    displayMode
    documentList {
      ${DOCUMENT_LIST_TITLE_FRAGMENT}
    }
    documentsPersonal {
      ${DOCUMENT_LIST_TITLE_FRAGMENT}
    }
    documentsSpouse {
      ${DOCUMENT_LIST_TITLE_FRAGMENT}
    }
    valueCollection{
      fieldName
      label
      value
      headerCollection
      subHeader
      questionHeader
      displayMode
      valueCollection{
        fieldName
        label
        value
        headerCollection
        subHeader
        questionHeader
        displayMode
      }
    }
  }
`;

export const SIGNATURE_VALUE_QUERY = gql`
  query applicantSignatures($applicationId: String!, $limit: Float!) {
    applicantSignatures(applicationId: $applicationId, limit: $limit) {
      id
      applicationId
      applicantAuthorizedUser
      signerAuthorizedUser
      signerType
      signerData
      email
      createdAt
      accessCode
      expiresAt
      status
      rejectReason
      completedAt
      isLocked
      lastUpdated
      lastViewed
      submittedOn
      signerProfile {
        ${IDPDATA_ALBERTACA_FRAGMENT}
      }
      lastSent
    }
  }
`;

export const SIGNATURE_SECURITY_QUERY = gql`
  query signatureSecurityInfo($signatureId: String!) {
    signatureSecurityInfo(signatureId: $signatureId) {
      id
      applicationId
      applicantAuthorizedUser
      signerAuthorizedUser
      signerType
      applicationData
      signerData
      createdAt
      accessCode
      expiresAt
      status
      completedAt
      lastUpdated
      lastViewed
      isLocked
      lastSent
      trackAttempts {
        failedAttempts
        lockedOutUntil
        lastAttempt
      }
    }
  }
`;

export const SIGNATURE_SNAPSHOT_QUERY = gql`
  query signatureSnapshotInfo($signatureId: String!) {
    signatureSnapshotInfo(signatureId: $signatureId) {
      id
      applicationId
      applicantAuthorizedUser
      signerAuthorizedUser
      signerType
      applicationData
      signerData
      applicantProfile {
        ${IDPDATA_ALBERTACA_FRAGMENT}
      } 
      email
      lastUpdated
      lastViewed
      submittedOn
      outputPdfUrl
      outputPdfFileName
      dataSnapshot {
        applicationId
        dataGroup{
          groupName
          groupCode
          groupDescription
          splitAfter
          dataFields {
            entityReference
            fieldReference
            snapshotValue{
              ${SNAPSHOT_VALUE_FRAGMENT_STATIC}
            }
            calloutContent{
              ${CALLOUT_CONTENT_FRAGMENT}
            }
          }
        }
      }
      signerProfile {
        ${IDPDATA_ALBERTACA_FRAGMENT}
      }
      status
      isLocked
      lastSent
    }
  }
`;

//used to attach signature info to application.
//excludes information that is not relavent or already exists in applications
export const SIGNATURE_INFO_MINIMAL = `
  id
  applicationId
  applicantAuthorizedUser
  signerAuthorizedUser
  signerType
  signerData
  signerProfile {
    ${IDPDATA_ALBERTACA_FRAGMENT}
  }
  email
  createdAt
  expiresAt
  status
  completedAt
  lastUpdated
  lastViewed
`;

//TODO: just started but look at signature.entity.ts for schema
export const GQL_SAVE_SIGNATURE = gql`
  mutation saveSignature($signatureInput: SignatureInput!, $forceNew: Boolean) {
    saveSignature(signatureInput: $signatureInput, forceNew: $forceNew) {
      id
      applicationId
      applicantAuthorizedUser
      signerAuthorizedUser
      signerType
      applicationData
      signerData
      email
      createdAt
      accessCode
      expiresAt
      status
      rejectReason
      completedAt
      isLocked
      lastViewed
      lastUpdated
      submittedOn
      outputPdfUrl
      outputPdfFileName
      signerProfile {
        ${IDPDATA_ALBERTACA_FRAGMENT}
      }
      applicantProfile {
        ${IDPDATA_ALBERTACA_FRAGMENT}
      }  
      dataSnapshot {
        applicationId
        dataGroup{
          groupName
          groupCode
          groupDescription
          splitAfter
          dataFields {
            entityReference
            fieldReference
            snapshotValue{
              ${SNAPSHOT_VALUE_FRAGMENT_STATIC}
            }
            calloutContent{
              ${CALLOUT_CONTENT_FRAGMENT}
            }
          }
      }
    }
  }
}
`;

export const GQL_DELETE_SIGNATURE = gql`
  mutation deleteSignature($signatureId: String!) {
    deleteSignature(signatureId: $signatureId)
  }
`;

export const GQL_UPDATE_LASTVIEWED = gql`
  mutation updateLastViewed($signatureId: String!) {
    updateLastViewed(id: $signatureId)
  }
`;

export const GQL_DELETEAll_SIGNATURE = gql`
  mutation deleteAllSignatures($applicationId: String!) {
    deleteAllSignatures(applicationId: $applicationId)
  }
`;

export const GQL_AUTHORIZE_SIGNATURE = gql`
  mutation authorizeSignature($signatureInput: SignatureInput!, $accessCode: String!) {
    authorizeSignature(signatureInput: $signatureInput, accessCode: $accessCode) {
      id
      status
      signerProfile {
        ${IDPDATA_ALBERTACA_FRAGMENT}
      }
    }
  }
`;

export const GQL_COMPLETE_SIGNATURE = gql`
  mutation completeSignature($signatureInput: SignatureInput!) {
    completeSignature(signatureInput: $signatureInput) {
      id
      completedAt
      status
      rejectReason
      signerProfile {
        ${IDPDATA_ALBERTACA_FRAGMENT}
      }
    }
  }
`;

export const GQL_LOCK_SIGNATURES = gql`
  mutation lockSignatures(
    $applicationId: String!
    $lock: Boolean!
    $dataSnapshot: DvSnapshotInput
    $updateSignatureStatus: String
  ) {
    lockSignatures(
      applicationId: $applicationId
      lock: $lock
      dataSnapshot: $dataSnapshot
      updateSignatureStatus: $updateSignatureStatus
    ) {
      id
      signerType
      isLocked
      expiresAt
      status
    }
  }
`;

export const GQL_SAVE_SIGNER_DATA = gql`
  mutation saveSignerData($id: String!, $signerData: JSONObject) {
    saveSignerData(id: $id, signerData: $signerData) {
      id
      signerData
    }
  }
`;

export const VALIDATE_ACCESS_CODE = gql`
  query ValidateAccessCode($signatureId: String!, $accessCode: String!) {
    validateAccessCode(signatureId: $signatureId, accessCode: $accessCode)
  }
`;

export const GQL_UPDATE_SIGNATURE_STATUS = gql`
  mutation updateSignatureStatus($signatureId: String!, $status: String!) {
    updateSignatureStatus(id: $signatureId, status: $status)
  }
`;

export const GQL_UPDATE_All_SIGNATURE_STATUS = gql`
  mutation updateAllSignatureStatus($applicationId: String!, $fromStatus: String!, $toStatus: String!) {
    updateAllSignatureStatus(applicationId: $applicationId, fromStatus: $fromStatus, toStatus: $toStatus)
  }
`;

export const SIGNATURE_REQUEST_ACCESS_INFO = gql`
  query signatureRequestAccessInfo($applicationId: String!, $signerType: String!) {
    signatureRequestAccessInfo(applicationId: $applicationId, signerType: $signerType) {
      signatureId
      accessCode
    }
  }
`;
